import { render, staticRenderFns } from "./GlobalConfigUpdateDialogSurcharge.vue?vue&type=template&id=6e78848e&scoped=true"
import script from "./GlobalConfigUpdateDialogSurcharge.vue?vue&type=script&lang=ts"
export * from "./GlobalConfigUpdateDialogSurcharge.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e78848e",
  null
  
)

export default component.exports